import { all, takeLatest } from 'redux-saga/effects'

import { blogApi } from '../../../services/'
import {
  createBlogRequest,
  getBlogDetailRequest,
  getBlogListRequest,
  getBlogStatusStatisticsRequest,
  updateBlogRequest,
  updateBlogStatusRequest
} from '../actions'
import { createBlogSaga } from './createBlog'
import { getBlogDetailSaga } from './getBlogDetail'
import { getBlogListSaga } from './getBlogList'
import { getBlogStatisticsSaga } from './getBlogStatistics'
import { updateBlogSaga } from './updateBlog'
import { updateBlogStatusSaga } from './updateBlogStatus'

export function* blogSaga() {
  try {
    yield all([
      takeLatest(getBlogListRequest as any, getBlogListSaga, blogApi),
      takeLatest(getBlogDetailRequest as any, getBlogDetailSaga, blogApi),
      takeLatest(createBlogRequest as any, createBlogSaga, blogApi),
      takeLatest(updateBlogRequest as any, updateBlogSaga, blogApi),
      takeLatest(updateBlogStatusRequest as any, updateBlogStatusSaga, blogApi),
      takeLatest(
        getBlogStatusStatisticsRequest as any,
        getBlogStatisticsSaga,
        blogApi
      )
    ])
  } catch (err) {
    // TODO: handle error
  }
}
